<template lang="pug">
  BaseModal.ModalAdditionalDocumentsDownload.modal-additional-documents-download(
    :value="value",
    v-bind="$attrs",
    v-on="$listeners",
    @close="onCancel()"
  )
    template(#title)
      .modal-additional-documents-download__title.is--desktop Free Checklist: Useful Documents for Selling Farmland
      .modal-additional-documents-download__title.is--mobile Free List of Useful Documents
    .modal-content-row
      .modal-content-row__image
        .image-wrap
          BaseImage(
            :src="require('images/general/additional-doc-file.png')",
            alt="whitepaper",
          )
      .modal-content-row__form
        FormAdditionalDocumentsDownload(
          @success="onSuccess",
        )
        .cancel-row
          a.link-3(
            href="#",
            @click.prevent="onCancel()"
            v-keydown-as-click
            tabindex="1"
          ) Cancel
</template>

<script>
import BaseModal from 'Components/Base/BaseModal';
import FormAdditionalDocumentsDownload from 'Components/FormAdditionalDocumentsDownload/FormAdditionalDocumentsDownload';

export default {
  name: 'ModalAdditionalDocumentsDownload',
  components: {
    FormAdditionalDocumentsDownload,
    BaseModal,
  },
  props: {
    value: Boolean,
  },
  methods: {
    onSuccess(value) {
      this.$emit('success', value);
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.modal-additional-documents-download
  &__title
    &.is--desktop
      @media screen and (max-width: 991px)
        display: none
    &.is--mobile
      display: none
      @media screen and (max-width: 991px)
        display: flex
        justify-content: center
        align-items: center
      @media screen and (max-width: 767px)
        font-size: 18px
        line-height: 28px
        width: 100%
        max-width: 240px
        margin: 0 auto
.modal-content
  @media screen and (max-width: 991px)
    padding-top: 110px !important
  &-row
    max-width: 1140px
    margin: 0 auto
    display: flex
    flex-direction: row
    justify-content: space-between
    padding: 0 15px
    @media screen and (max-width: 767px)
      flex-direction: column
      align-items: center
      padding: 0
    &__image
      width: 100%
      height: 100%
      padding: 0 15px
      padding-right: 30px
      @media screen and (max-width: 767px)
        margin-bottom: 30px
        padding-right: 15px
      .image-wrap
        position: relative
        width: 100%
        max-width: 300px
        margin: 0 auto
        margin-top: 10px
        @media screen and (max-width: 767px)
          max-width: 190px
        img
          width: 100%
          box-shadow: 0 5px 15px 0 rgba(0,0,0,0.05)
        &:before
          +mt(.3s)
          content: ''
          position: absolute
          background: $support_lightgray
          width: 100%
          height: 100%
          z-index: -1
          top: 50%
          right: 0
          transform: translate(0%, -50%) rotate(-7deg)
    &__form
      width: 100%
      max-width: 555px
      flex-shrink: 0
      .cancel-row
        margin-top: 20px
        text-align: center
        @media screen and (max-width: 576px)
          margin-top: 30px
</style>
